import { faExclamation, faUserShield } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { getAllVigilants } from "../../helpers/api/security";
import handleErrorMessage, {
  getErrorMessage,
} from "../../helpers/errors/handleErrorMessage";
import { isIterableArray } from "../../helpers/utils";
import Avatar from "../common/Avatar";
import SectionCardHeader from "../common/SectionCardHeader";
import Filter from "../common/Filter";
import Flex from "../common/Flex";
import PageHeader from "../common/PageHeader";
import SupportLink from "../root/support/components/SupportLink";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";

const Security = () => {
  const { role } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [vigilants, setVigilants] = useState({
    data: [],
    isLoading: true,
    error: null,
  });
  const [params, setParams] = useState({
    condominium: selectedCondominium,
    isProvider: false,
  });
  const filter_options = [
    { value: 0, displayName: "Contratado", disabled: false },
    { value: 1, displayName: "Pertenecientes a un proveedor", disabled: false },
  ];

  useEffect(() => {
    let isMounted = true;

    if (selectedCondominium) {
      isMounted && setVigilants((prev) => ({ ...prev, isLoading: true }));
      getAllVigilants(1, 5, params)
        .then(
          ({ data }) =>
            isMounted && setVigilants((prev) => ({ ...prev, data }))
        )
        .catch((error) => {
          handleErrorMessage(error);
          isMounted &&
            setVigilants((prev) => ({
              ...prev,
              error: getErrorMessage(error),
            }));
        })
        .finally(
          () =>
            isMounted && setVigilants((prev) => ({ ...prev, isLoading: false }))
        );
    }

    // eslint-disable-next-line
    return () => {
      isMounted = false;
    };
  }, [selectedCondominium, params]);

  return (
    <>
      <PageHeader
        title="Seguridad"
        titleTag="h2"
        description={"Gestiona la seguridad en el condominio."}
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <Card>
        <SectionCardHeader
          icon={faUserShield}
          title="Vigilantes"
          description="El personal de vigilancia del condominio."
          action={{ label: "Gestionar", to: "/dashboard/security/vigilants" }}
        />
        <CardBody
          className={classNames("fs--1", {
            "p-0": isIterableArray(vigilants.data),
          })}
        >
          <Row
            className={classNames("mb-3", {
              "mt-3": isIterableArray(vigilants.data),
            })}
          >
            <Col>
              <Flex>
                <Filter
                  keyField="isProvider"
                  options={filter_options}
                  selectType={setParams}
                  dateFilter={false}
                />
              </Flex>
            </Col>
          </Row>
          <PreloadState
            cond={isIterableArray(vigilants.data)}
            loading={vigilants.isLoading}
          >
            <Or value={true}>
              <>
                <Row className="m-0">
                  <Col className="p-0">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th
                            className="align-middle "
                            style={{ width: "auto" }}
                          ></th>
                          <th className="text-center align-middle">DNI</th>
                          <th className="align-middle">Nombre</th>
                          <th className="text-center align-middle">
                            N° de teléfono
                          </th>
                          <th className="text-center align-middle">
                            Fecha de creación
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {vigilants.data.map(
                          (
                            {
                              people: {
                                firstname,
                                lastname,
                                phone,
                                address,
                                dni,
                                image,
                              },
                              auth_id,
                              created_at,
                            },
                            i
                          ) => {
                            return (
                              <tr key={i}>
                                <td
                                  className="text-center justify-center"
                                  style={{ width: "auto" }}
                                >
                                  <Avatar
                                    src={
                                      image
                                        ? import.meta.env.VITE_URL +
                                          "/storage/" +
                                          image
                                        : undefined
                                    }
                                  />
                                </td>
                                <td className="text-center align-middle">
                                  <b>
                                    <Link
                                      to={{
                                        pathname: `/dashboard/security/vigilants/${auth_id}`,
                                        state: {
                                          vigilant: {
                                            firstname,
                                            lastname,
                                            phone,
                                            dni,
                                            image,
                                            address,
                                          },
                                        },
                                      }}
                                    >
                                      {" "}
                                      {dni}
                                    </Link>
                                  </b>
                                </td>
                                <td className="align-middle">
                                  {firstname} {lastname}
                                </td>
                                <td className="text-center align-middle">
                                  {phone || "No registrado"}
                                </td>
                                <td className="text-center align-middle">
                                  {moment(created_at).format("DD/MM/YYYY")}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </>
            </Or>
            <Or value={false}>
              <PreloadState cond={!!vigilants.error}>
                <Or value={true}>
                  <Message
                    value={"manager"}
                    color={"info"}
                    className="p-3"
                    align="left"
                    icon={faExclamation}
                  >
                    {vigilants.error}
                  </Message>
                </Or>
                <Or value={false}>
                  <Message
                    value={"manager"}
                    color={"info"}
                    className="p-3"
                    align="left"
                    icon={faExclamation}
                  >
                    No hay vigilantes registrados actualmente.
                  </Message>
                </Or>
              </PreloadState>
            </Or>
          </PreloadState>
        </CardBody>
      </Card>
    </>
  );
};

export default Security;
